import { render, staticRenderFns } from "./CashPolicy.vue?vue&type=template&id=05913ac7&"
import script from "./CashPolicy.vue?vue&type=script&lang=js&"
export * from "./CashPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports